import React from 'react';
import { FaCheck, FaChalkboardTeacher, FaClock } from 'react-icons/fa';

const ConversionBlock: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 my-8">
      <h2 className="text-3xl font-bold text-center text-blue-900 mb-8">Your IELTS Success is Just a Few Clicks Away</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
        <section className="bg-white p-6 shadow-md rounded-md">
          <h3 className="text-xl font-semibold mb-4 text-blue-600">Why IELTS Matters</h3>
          <p className="mb-4">Your IELTS score can change your life. It's not just a test - it's your gateway to:</p>
          <ul className="list-disc list-inside ml-4 text-gray-600">
            <li>Career advancement</li>
            <li>International education</li>
            <li>Immigration opportunities</li>
          </ul>
          <p className="mt-4 text-gray-600">Don't let a low score hold you back from achieving your dreams.</p>
        </section>

        <section className="bg-white p-6 shadow-md rounded-md">
          <h3 className="text-xl font-semibold mb-4 text-blue-600">Prepare Smarter, Not Harder</h3>
          <p className="mb-4">With our platform, you can:</p>
          <ul className="list-disc list-inside ml-4 text-gray-600">
            <li>Master the toughest part of IELTS - Writing Task 2</li>
            <li>Learn through practice, not just theory</li>
            <li>Understand the exact structure and requirements for top scores</li>
            <li>Get personalized improvement suggestions for each essay</li>
          </ul>
        </section>
      </div>

      <section className="bg-blue-50 p-6 rounded-lg shadow-md mb-12">
        <h3 className="text-2xl font-semibold mb-6 text-center text-blue-900">Why We're Your Best Choice</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h4 className="font-semibold mb-3 flex items-center text-blue-700">
              <FaChalkboardTeacher className="mr-2" />
              Compared to ChatGPT:
            </h4>
            <ul className="list-none ml-4">
              <li className="mb-2 flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Scores verified against official IELTS-graded essays</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Visual highlights of areas for improvement in your essay</span>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3 flex items-center text-blue-700">
              <FaClock className="mr-2" />
              Compared to IELTS Teachers:
            </h4>
            <ul className="list-none ml-4">
              <li className="mb-2 flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Instant feedback - minutes, not days</span>
              </li>
              <li className="mb-2 flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Significantly more affordable - pay for 100 essay checks, not just one hour</span>
              </li>
              <li className="mb-2 flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Available 24/7, no appointments needed</span>
              </li>
              <li className="flex items-start">
                <FaCheck className="text-green-500 mr-2 mt-1 flex-shrink-0" />
                <span>Practice from the comfort of your home</span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="text-center">
        <h3 className="text-2xl font-semibold mb-4 text-blue-900">Join Thousands of Successful Students</h3>
        <p className="mb-6 text-gray-600">We've helped check over 100,000 essays. Our students trust us, and you can too.</p>
      </section>
    </div>
  );
};

export default ConversionBlock;